import { Link } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

function SoonBadge() {
  return (
    <span className="text-xs px-2 py-0.5 rounded-md font-medium bg-surface2 text-muted/60 border border-line">
      Скоро
    </span>
  )
}

function ComingSoonCard({ icon, title, description }) {
  return (
    <div className="flex items-center gap-4 p-4 rounded-xl bg-surface border border-line opacity-50 select-none">
      <div className="w-10 h-10 rounded-lg bg-surface2 flex items-center justify-center flex-shrink-0 text-xl">
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-sm font-semibold text-fg">{title}</p>
          <SoonBadge />
        </div>
        {description && <p className="text-xs text-muted mt-0.5">{description}</p>}
      </div>
    </div>
  )
}

export default function Contact() {
  const isAuth = useAuthStore((s) => s.isAuth)

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-12">
      <div className="mb-10">
        <h1 className="text-3xl font-black text-fg mb-2">Контакты</h1>
        <p className="text-muted">Мы только запустились — многое ещё впереди</p>
      </div>

      <div className="flex flex-col gap-8">
        {/* Сообщество */}
        <section className="flex flex-col gap-3">
          <h2 className="text-xs font-semibold text-muted uppercase tracking-wider">Сообщество</h2>
          <div className="flex flex-col gap-2">
            <ComingSoonCard
              icon={<TelegramIcon />}
              title="Telegram"
              description="Новости и обновления"
            />
            <ComingSoonCard
              icon={<DiscordIcon />}
              title="Discord"
              description="Общение и обсуждения"
            />
          </div>
        </section>

        {/* Мы в сети */}
        <section className="flex flex-col gap-3">
          <h2 className="text-xs font-semibold text-muted uppercase tracking-wider">Мы в сети</h2>
          <div className="flex flex-col gap-2">
            <ComingSoonCard icon={<VkIcon />} title="ВКонтакте" />
            <ComingSoonCard icon={<XIcon />} title="X (Twitter)" />
          </div>
        </section>

        {/* Поддержка — только для авторизованных */}
        {isAuth && (
          <section className="flex flex-col gap-3">
            <h2 className="text-xs font-semibold text-muted uppercase tracking-wider">Поддержка</h2>
            <div className="p-5 rounded-xl bg-surface border border-line flex flex-col gap-4">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-accent/10 border border-accent/20 flex items-center justify-center flex-shrink-0">
                  <SupportIcon />
                </div>
                <div>
                  <p className="text-sm font-semibold text-fg">Служба поддержки</p>
                  <p className="text-xs text-muted mt-0.5 leading-relaxed">
                    Вопросы по сайту, ошибки в переводе, проблемы с аккаунтом
                  </p>
                </div>
              </div>
              <Link
                to="/support"
                className="w-full py-2.5 rounded-xl text-sm font-bold text-center bg-accent text-on-accent hover:opacity-90 transition-opacity"
              >
                Написать в поддержку
              </Link>
            </div>
          </section>
        )}
      </div>
    </div>
  )
}

function TelegramIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-[#29b6f6]">
      <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.93 6.79l-1.69 7.96c-.12.55-.45.68-.91.42l-2.52-1.86-1.21 1.17c-.13.13-.25.25-.51.25l.18-2.56 4.65-4.2c.2-.18-.04-.28-.31-.1L8.06 14.6l-2.47-.77c-.54-.17-.55-.54.11-.79l9.65-3.72c.44-.16.83.11.68.77z" fill="currentColor"/>
    </svg>
  )
}

function DiscordIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-[#7289da]">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057c.002.022.015.043.032.055a19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" fill="currentColor"/>
    </svg>
  )
}

function VkIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" className="text-[#4a76a8]">
      <path d="M12.785 16.241s.288-.032.436-.194c.136-.148.132-.427.132-.427s-.02-1.304.585-1.498c.596-.19 1.365 1.26 2.179 1.815.615.418 1.082.326 1.082.326l2.17-.03s1.137-.071.598-1.07c-.044-.08-.312-.662-1.607-1.87-1.357-1.267-1.175-1.062.459-3.253.998-1.33 1.396-2.142 1.271-2.49-.12-.332-.848-.244-.848-.244l-2.44.015s-.181-.025-.315.056c-.132.08-.216.267-.216.267s-.387 1.028-.903 1.902c-1.088 1.85-1.523 1.948-1.7 1.833-.414-.267-.31-1.073-.31-1.646 0-1.79.27-2.535-.527-2.727-.265-.065-.46-.107-1.136-.114-.869-.009-1.603.003-2.02.206-.277.135-.49.437-.36.454.161.022.527.099.721.363.25.34.241 1.103.241 1.103s.144 2.11-.336 2.371c-.328.18-.779-.187-1.747-1.865a19.963 19.963 0 0 1-.879-1.92s-.073-.178-.203-.274a1.01 1.01 0 0 0-.378-.152l-2.32.015s-.348.01-.476.161c-.114.135-.009.414-.009.414s1.814 4.244 3.867 6.382c1.883 1.96 4.02 1.832 4.02 1.832h.968z" fill="currentColor"/>
    </svg>
  )
}

function XIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" className="text-muted/60">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
    </svg>
  )
}

function SupportIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="text-accent">
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" fill="currentColor"/>
    </svg>
  )
}
